import React from "react";
import styles from "./Preview.module.css";

const Reflections = ({ files, onFileClick }) => (
  <div className={styles.Preview}>
  {files.map((file, idx) => (
    <div
      className={styles.file}
      key={file.id}
      onClick={() => onFileClick(idx)}
    >
      <img src={file.url} alt="" />
      <div className={styles.name}>{file.title}</div>
    </div>
  ))}
</div>
);
export default Reflections;
